import React, { useState, useContext, useEffect } from "react";
import {
  Footer,
  Header,
  emailRegex,
  DotsLoader,
  InputTypePhone,
} from "../../components";
import "./styles.css";
import { Modal } from "react-responsive-modal";
import { Images } from "../../theme";
import Tooltip from "react-simple-tooltip";
import { Link, useLocation } from "react-router-dom";
import InputTextCustom from "../../components/InputTextCustom";
import { GlobalContext } from "../../context/GlobalContext";
import PromoCodeModal from "./PromoCodeModal";
import StripeModal from "./StripeModal";
import { useTranslation } from "react-i18next";
import { enumerateDaysBetweenDates } from "../../util/genericFunctions";

export default function CheckOut() {
  const getContextItems = useContext(GlobalContext);
  let { promocode, create_rent_store, isLoading, get_tax_amount, servicesFee } =
    getContextItems;
  const { t } = useTranslation();

  const uselocation = useLocation();
  let { categoryData, selectedDayRange, selectDay, days, item } =
    uselocation.state?.payload;

  let dailyPrice = parseFloat(item?.daily_price);
  let weeklyPrice = parseFloat(item?.weekly_price) / 7;
  let monthlyPrice = parseFloat(item?.monthly_price) / 30;

  let fromDate = `${selectedDayRange.from?.year}-${selectedDayRange.from?.month}-${selectedDayRange.from?.day}`;
  let toDate = `${selectedDayRange.to?.year}-${selectedDayRange.to?.month}-${selectedDayRange.to?.day}`;
  let taxValue = servicesFee.service_fees + servicesFee.stripe_fees;

  function TotalAmount() {
    let amount =
      selectDay == 1 ? dailyPrice : selectDay == 2 ? weeklyPrice : monthlyPrice;
    let totalAmount = amount * days;
    let findText = taxValue / 100;
    let myText = totalAmount * findText;
    var myValue = totalAmount + myText;

    if (promocode.id) {
      let findAfterTax = promocode?.reward / 100;
      let myAfterTax = myValue * findAfterTax;
      let disValue = myValue - myAfterTax;
      return {
        netValue: disValue.toFixed(1),
        taxAfterCal: myText.toFixed(1),
        amount: amount,
        totalAmount: totalAmount,
        discount: myAfterTax,
      };
    } else
      return {
        netValue: myValue.toFixed(1),
        taxAfterCal: myText.toFixed(1),
        amount: amount,
        totalAmount: totalAmount,
        discount: 0,
      };
  }

  const [promoModal, setPromoModal] = useState(false);
  const [paymentOpen, setPaymentOpen] = useState(false);
  const [rowData, setRowData] = useState({});
  const [formErrors, setFormErrors] = useState({});

  useEffect(() => {
    let userData = sessionStorage.getItem("user");
    userData && setRowData(JSON.parse(userData));
    !servicesFee.service_fees && get_tax_amount();
  }, []);

  const onChangeInput = async (data) => {
    setPaymentOpen(false);
    setFormErrors(false);
    const { selectedInput } = data;
    let upData = { ...rowData };
    upData[selectedInput] = data.value;
    data.state(upData);
  };

  function checkValidation() {
    let { firstname, lastname, email, phone, address, country } = rowData;

    if (!firstname) {
      setFormErrors({ ...formErrors, firstnameError: t("First_Name") });
    } else if (!lastname) {
      setFormErrors({
        ...formErrors,
        lastnameError: t("Last_Name"),
      });
    } else if (!email) {
      setFormErrors({ formErrors, emailError: t("Required_Email") });
    } else if (!email.match(emailRegex)) {
      setFormErrors({ formErrors, emailError: t("Invalid_Email") });
    } else if (!phone) {
      setFormErrors({ formErrors, phoneError: t("Required_Phone_numbr") });
    } else if (!address) {
      setFormErrors({ formErrors, addressError: t("Required_Phone_numbr") });
    } else if (!country) {
      setFormErrors({ formErrors, countryError: t("Required_Phone_numbr") });
    } else {
      setPaymentOpen(true);
    }
  }

  function giveData(data) {
    let { firstname, lastname, email, phone, address, country, note } = rowData;
    let to = selectedDayRange.to ? selectedDayRange.to : selectedDayRange.from;
    let days = selectedDayRange.to
      ? enumerateDaysBetweenDates(fromDate, toDate)
      : [selectedDayRange.from];

    let payload = {
      firstname,
      lastname,
      email,
      phone,
      address,
      region: country,
      note,
      price: TotalAmount().amount,
      total: TotalAmount().totalAmount,
      duration: { to, days },
      item_id: item.id,
      stripeToken: data.id,
      fees: TotalAmount().taxAfterCal,
      discount: TotalAmount().discount,
    };
    if (promocode?.id) payload.promocode = promocode?.code;
    setPaymentOpen(false);
    create_rent_store(payload);
  }

  return (
    <>
      <Header />
      <div className="container">
        <div className="row">
          <div className="col-12 mt-3 mb-3">
            <Link to="/">
              <span className="homeHeading">{t("Home")}</span>
            </Link>
            {categoryData?.name ? (
              <span className="arrowStyle">
                {" "}
                <img src={Images.ArrowNew} alt="image" />{" "}
              </span>
            ) : null}
            <span className="homeHeading">{categoryData?.name}</span>
            <span className="arrowStyle">
              {" "}
              <img src={Images.ArrowNew} alt="image" />{" "}
            </span>
            <span className="homeHeading">{item?.title}</span>
            <span className="arrowStyle">
              {" "}
              <img src={Images.ArrowNew} alt="image" />{" "}
            </span>

            <span className="pageHeading">{t("Checkout")}</span>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-md-8 checkOutBox">
            <h1 className="addressHeading">{t("Checkout")}</h1>
            <div className="row mt-4">
              <div className="col-md-6 col-6">
                <InputTextCustom
                  headingLabel={t("First_Name")}
                  value={rowData.firstname}
                  errorState={formErrors.firstnameError}
                  onChange={(e) => {
                    onChangeInput({
                      value: e.target.value,
                      state: setRowData,
                      selectedInput: "firstname",
                      selectedRow: rowData,
                    });
                  }}
                />
              </div>
              <div className="col-md-6 col-6">
                <InputTextCustom
                  headingLabel={t("Last_Name")}
                  value={rowData.lastname}
                  errorState={formErrors.lastnameError}
                  onChange={(e) => {
                    onChangeInput({
                      value: e.target.value,
                      state: setRowData,
                      selectedInput: "lastname",
                      selectedRow: rowData,
                    });
                  }}
                />
              </div>

              <div className="col-md-6">
                <InputTextCustom
                  headingLabel={t("Email")}
                  value={rowData.email}
                  errorState={formErrors.emailError}
                  onChange={(e) => {
                    onChangeInput({
                      value: e.target.value,
                      state: setRowData,
                      selectedInput: "email",
                      selectedRow: rowData,
                    });
                  }}
                />
              </div>
              <div className="col-md-6">
                <InputTypePhone
                  headingLabel={t("Phone_Number")}
                  value={rowData.phone}
                  type="number"
                  errorState={formErrors.phoneError}
                  onChange={(e) => {
                    onChangeInput({
                      value: e.target.value,
                      state: setRowData,
                      selectedInput: "phone",
                      selectedRow: rowData,
                    });
                  }}
                />
              </div>
              <div className="col-md-6 col-6">
                <InputTextCustom
                  headingLabel={t("Address")}
                  value={rowData.address}
                  errorState={formErrors.addressError}
                  onChange={(e) => {
                    onChangeInput({
                      value: e.target.value,
                      state: setRowData,
                      selectedInput: "address",
                      selectedRow: rowData,
                    });
                  }}
                />
              </div>
              <div className="col-md-6 col-6">
                <InputTextCustom
                  headingLabel={t("Country_or_Region")}
                  value={rowData.country}
                  errorState={formErrors.countryError}
                  onChange={(e) => {
                    onChangeInput({
                      value: e.target.value,
                      state: setRowData,
                      selectedInput: "country",
                      selectedRow: rowData,
                    });
                  }}
                />
              </div>
              <div className="col-md-12 col-12">
                <label class="control-label customStyleLabel">
                  {t("Note_to_lender")}
                </label>
                <div>
                  <textarea
                    id="w3review"
                    name="w3review"
                    rows="4"
                    className="form-control textAreaStyle"
                    value={rowData.note}
                    onChange={(e) => {
                      onChangeInput({
                        value: e.target.value,
                        state: setRowData,
                        selectedInput: "note",
                        selectedRow: rowData,
                      });
                    }}
                  ></textarea>
                </div>
              </div>
              {/* <div className="col-md-12 col-12 mt-3 mb-5">
                <div class="form-check">
                  <input
                    class="form-check-input customStyleCheckBox"
                    type="checkbox"
                    value=""
                    id="defaultCheck1"
                  />
                  <label
                    class="form-check-label customStyleLabel"
                    for="defaultCheck1"
                  >
                    Add to address book
                  </label>
                </div>
              </div> */}
            </div>
          </div>
          <div className="col-md-4 mb-5">
            <div className="card">
              <h1 className="riderName">{item?.title}</h1>

              <span className="BikesText">{categoryData?.name}</span>

              <div className="mt-4">
                <span className="deliveryText">
                  {selectedDayRange.from?.day}/{selectedDayRange.from?.month}/
                  {selectedDayRange.from?.year}{" "}
                  {selectedDayRange.to?.day
                    ? `- ${selectedDayRange.to?.day}/${selectedDayRange.to?.month}/${selectedDayRange.to?.year}`
                    : null}
                </span>
                {/* <span className="deliveryChange">Change</span> */}
              </div>

              <hr className="lineStyle" />

              <div>
                <span className="deliverytex">
                  ${TotalAmount().amount} x {days} {t("Days")}
                </span>
                <span className="deliverytexPrice">
                  ${TotalAmount().totalAmount}
                </span>
              </div>
              <div>
                <span className="deliverytex">
                  {t("Service_fee")}
                  <Tooltip content={t("What_Service_Fee_Here")}>
                    <img
                      className="tooltipFee"
                      src={Images.information_button}
                      alt="image"
                    />
                  </Tooltip>
                </span>

                <span className="deliverytexPrice">
                  {servicesFee.service_fees + servicesFee.stripe_fees}%
                </span>
              </div>

              {selectDay == 1 ? null : (
                <div>
                  <span className="deliverytex">
                    {t("Extended_rental_discount")}
                  </span>
                  <span className="deliverytexPrice">
                    $
                    {selectDay == 2
                      ? (dailyPrice * days - weeklyPrice * days).toFixed(1)
                      : (dailyPrice * days - monthlyPrice * days).toFixed(1)}
                  </span>
                </div>
              )}

              <hr className="lineStyle" />
              {promocode.id ? (
                <div className="d-flex justify-content-between">
                  <div className="deliveryTotal">{promocode?.data[0]}</div>
                  <div className="deliveryTotalPrice" style={{ color: "red" }}>
                    -{promocode?.reward}%
                  </div>
                </div>
              ) : (
                <a onClick={() => setPromoModal(true)} className="promoCode">
                  {t("Have_a_promo_code")}
                </a>
              )}
              <div>
                <span className="deliveryTotal">{t("Total")}</span>
                <span className="deliveryTotalPrice">
                  ${TotalAmount().netValue}
                </span>
              </div>

              {paymentOpen ? (
                <StripeModal giveData={giveData} />
              ) : (
                <button
                  onClick={checkValidation}
                  disabled={isLoading || !servicesFee?.service_fees}
                  class="btn-custom btn-light btnProductCheck"
                >
                  {isLoading ? <DotsLoader /> : t("PLACE_ORDER")}
                </button>
              )}

              <p className="placeOrderDec">{t("Order_Descreption")}</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <Modal open={promoModal} onClose={() => setPromoModal(false)} center>
        <PromoCodeModal
          rowData={rowData}
          onClose={() => setPromoModal(false)}
        />
      </Modal>
    </>
  );
}
